import React from "react"
import { makeStyles } from "@material-ui/core"
import { Internet } from "src/utils/Internet"

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(0.5),
  },
  logo: {
    width: 120,
    height: 50,
    paddingLeft: 10,
    objectFit: "contain",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
}))

const Logo = ({ img, ...rest }) => {
  const classes = useStyles()
  return (
    <div className={classes.wrapper}>
      <img alt="Logo" className={classes.logo} src={img} {...rest} />
      <Internet />
    </div>
  )
}

export default Logo
